export const config = {
  APP_ID: "1b5921da",
  API_KEY: "8faae23453ca433d89a2cbf68fd8a189",
  BASE_URL: "https://api.adzuna.com/v1/api/jobs",
  BASE_PARAMS: "search/1?&results_per_page=20&content-type=application/json"
};
